import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPayrollItem from './payroll-item.reducer';

export const selectPayrollItemState =
    createFeatureSelector<fromPayrollItem.State>(
        fromPayrollItem.payrollItemsFeatureKey
    );

export const { selectIds, selectEntities, selectAll, selectTotal } =
    fromPayrollItem.adapter.getSelectors(selectPayrollItemState);

export const selectLaborTypeProperty = createSelector(
    selectPayrollItemState,
    (state: fromPayrollItem.State) => state.LaborTypes
);

export const getPayrollItemsFor = (EmployeeListID: string) =>
    createSelector(selectAll, payroll =>
        payroll.filter(x => x.EmployeeListID === EmployeeListID)
    );

/** Payroll items where IsActive is not false (for dropdowns - excludes inactivated items). */
export const selectActivePayrollItems = createSelector(selectAll, items =>
    items.filter(x => x.IsActive !== false)
);
